<template>
  <div class="m-page m-selfbuild-page">
    <section class="m-self-hero">
      <div class="m-hero-copy">
        <h1>化化自建房服务</h1>
        <p class="m-hero-subtitle">用工程级标准，守护您的百年宅</p>
        <p class="m-hero-desc">从图纸到入住，先建后付、平台托底、在线验收，让乡村建房更透明、更放心。</p>
        <button class="m-primary-btn" type="button" @click="openQrModal">立即体验</button>
      </div>
      <img class="m-hero-img" src="https://obs.huahuaeco.com/official/SelfBuildingTopPicture.png" alt="化化自建房服务" />
    </section>

    <section class="m-section">
      <h2>自建房业主的四大难题</h2>
      <p class="m-section-subtitle">农村建房，为什么总是“提心吊胆”？</p>

      <article
        v-for="item in questionCards"
        :key="item.title"
        class="m-info-card m-question-card"
        :class="{ 'has-icon': item.img }"
      >
        <div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </div>
        <img v-if="item.img" class="m-card-icon" :src="item.img" :alt="item.title" />
      </article>
    </section>

    <section class="m-section">
      <h2>化化平台四大核心保障机制</h2>
      <p class="m-section-subtitle">把“鲁班奖工程”的管理标准，用在你的家。</p>

      <article
        v-for="item in guaranteeCards"
        :key="item.title"
        class="m-info-card m-guarantee-card"
        :class="{ 'has-icon': item.img }"
      >
        <div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </div>
        <img v-if="item.img" class="m-card-icon" :src="item.img" :alt="item.title" />
      </article>
    </section>

    <section class="m-section m-process-section">
      <h2>服务流程</h2>
      <p class="m-section-subtitle">从发布需求到竣工交付，全程线上留痕，手机就能搞定</p>

      <div class="m-process-panel">
        <article
          v-for="(step, index) in serviceSteps"
          :key="step.title"
          class="m-process-step"
        >
          <div class="m-process-index">{{ String(index + 1).padStart(2, '0') }}</div>
          <div>
            <h3>{{ step.title }}</h3>
            <p>{{ step.desc }}</p>
          </div>
        </article>
      </div>
    </section>

    <section id="experience" class="m-section m-experience-section">
      <h2>立即体验</h2>
      <p class="m-section-subtitle">服务至业主满意为止，不负每个客户的信任</p>
      <!-- <button class="m-secondary-btn" type="button" @click="openQrModal">立即体验</button> -->
      <img class="m-experience-qrs" src="https://obs.huahuaeco.com/official/selfBuildServier.png" alt="扫码体验小程序与获取建房报价" />
    </section>

    <div v-if="showQrModal" class="m-qr-overlay" @click.self="closeQrModal">
      <div class="m-qr-dialog" role="dialog" aria-modal="true" aria-label="小程序二维码">
        <button class="m-qr-close" type="button" aria-label="关闭二维码" @click="closeQrModal">×</button>
        <img :src="qrCodeUrl" alt="化化小程序二维码" />
      </div>
    </div>
    <SeoStaticImages :images="seoImages" />
  </div>
</template>

<script>
import { useHead } from '@unhead/vue'
import { getPageHead } from '../../utils/page-head'
import SeoStaticImages from '../../components/SeoStaticImages.vue'

export default {
  name: 'SelfBuildServicesMobilePage',
  components: {
    SeoStaticImages
  },
  setup() {
    useHead(getPageHead('selfBuildServices', 'https://www.huahuaeco.com/selfBuildServices'))
  },
  data() {
    return {
      seoImages: [
        'https://obs.huahuaeco.com/official/SelfBuildingTopPicture.png',
        'https://obs.huahuaeco.com/official/selfBuildQuestion.png',
        'https://obs.huahuaeco.com/official/Product/img5safe.png',
        'https://obs.huahuaeco.com/official/selfBuildServier.png',
        'https://obs.huahuaeco.com/official/qrcode.png'
      ],
      questionCards: [
        {
          title: '没标准',
          desc: '没有规范图纸和统一工艺标准，全凭师傅口头经验，质量好坏全看运气。',
          img: 'https://obs.huahuaeco.com/official/selfBuildQuestion.png'
        },
        {
          title: '没人管',
          desc: '自己不懂行，又没法天天盯工地，等发现问题时往往已经难改。'
        },
        {
          title: '钱难控',
          desc: '付款节奏不清晰，材料人工一笔糊涂账，临时加钱和停工让人被动。'
        },
        {
          title: '没售后',
          desc: '房子建完施工队就离场，墙面开裂、屋顶漏水等问题没人负责。'
        }
      ],
      guaranteeCards: [
        {
          title: '先建后付，资金托管',
          desc: '建房款由平台与第三方支付机构联合托管，按地基、主体、封顶、竣工等节点验收后付款。',
          img: 'https://obs.huahuaeco.com/official/Product/img5safe.png'
        },
        {
          title: '在线验收，过程透明',
          desc: '关键节点上传影像，业主可通过小程序对照标准清单在线确认，异地也能实时监工。'
        },
        {
          title: '平台托底，售后无忧',
          desc: '施工方跑路或严重违约时，平台协调团队接手处理，保障工程持续推进。'
        },
        {
          title: '严选队伍，匠心筑家',
          desc: '施工队需通过资质审核、在线考核和业主评价筛选，用公开数据辅助决策。'
        }
      ],
      serviceSteps: [
        { title: '发布需求', desc: '在线提交建房意向' },
        { title: '免费量房/勘测', desc: '专业人员上门勘测' },
        { title: '方案与报价', desc: '提供设计方案和预算清单' },
        { title: '确认下单', desc: '确认报价方案后下单' },
        { title: '签约与托管金额', desc: '签约后分阶段托管建房款' },
        { title: '施工交付', desc: '按节点和标准施工' },
        { title: '节点与竣工验收', desc: '关键节点在线验收' },
        { title: '售后保障', desc: '按约定享受售后服务' }
      ],
      qrCodeUrl: 'https://obs.huahuaeco.com/official/qrcode.png',
      showQrModal: false
    }
  },
  methods: {
    openQrModal() {
      this.showQrModal = true
    },
    closeQrModal() {
      this.showQrModal = false
    }
  }
}
</script>

<style scoped lang="scss">
.m-page {
  min-height: 100vh;
  padding-top: calc(88 * var(--rpx));
  background: #f4f7fb;
  overflow: hidden;
}

.m-self-hero {
  position: relative;
  min-height: calc(540 * var(--rpx));
  padding: calc(56 * var(--rpx)) calc(32 * var(--rpx)) calc(40 * var(--rpx));
  background:
    radial-gradient(circle at 78% 34%, rgba(225, 239, 255, 0.95) 0%, rgba(244, 248, 252, 0.5) 42%, rgba(255, 255, 255, 0) 72%),
    #fff;
  overflow: hidden;
}

.m-hero-copy {
  position: relative;
  z-index: 2;
  width: calc(420 * var(--rpx));
  max-width: 62%;

  h1 {
    margin: 0;
    color: #262626;
    font-size: calc(42 * var(--rpx));
    font-weight: 700;
    line-height: 1.28;
  }
}

.m-hero-subtitle {
  margin: calc(20 * var(--rpx)) 0 0;
  color: #262626;
  font-size: calc(26 * var(--rpx));
  font-weight: 600;
  line-height: 1.5;
}

.m-hero-desc {
  margin: calc(16 * var(--rpx)) 0 0;
  color: #8c8c8c;
  font-size: calc(22 * var(--rpx));
  line-height: 1.7;
}

.m-primary-btn {
  width: calc(176 * var(--rpx));
  height: calc(58 * var(--rpx));
  margin-top: calc(28 * var(--rpx));
  border: 0;
  border-radius: calc(999 * var(--rpx));
  color: #fff;
  font-size: calc(24 * var(--rpx));
  font-weight: 600;
  background: linear-gradient(90deg, #5bf7fe, #198cfe);
  box-shadow: 0 calc(12 * var(--rpx)) calc(22 * var(--rpx)) rgba(25, 140, 254, 0.22);
}

.m-secondary-btn {
  display: block;
  width: calc(220 * var(--rpx));
  height: calc(62 * var(--rpx));
  margin: calc(36 * var(--rpx)) auto 0;
  border: 0;
  border-radius: calc(999 * var(--rpx));
  color: #fff;
  font-size: calc(24 * var(--rpx));
  font-weight: 600;
  background: linear-gradient(90deg, #5bf7fe, #198cfe);
  box-shadow: 0 calc(12 * var(--rpx)) calc(22 * var(--rpx)) rgba(25, 140, 254, 0.22);
}

.m-hero-img {
  position: absolute;
  right: calc(12 * var(--rpx));
  bottom: calc(32 * var(--rpx));
  z-index: 1;
  width: calc(390 * var(--rpx));
  max-width: 58%;
  height: auto;
}

.m-section {
  padding: calc(56 * var(--rpx)) calc(24 * var(--rpx)) 0;

  h2 {
    margin: 0;
    color: #262626;
    text-align: center;
    font-size: calc(34 * var(--rpx));
    font-weight: 700;
    line-height: 1.35;
  }
}

.m-section-subtitle {
  width: calc(620 * var(--rpx));
  max-width: 100%;
  margin: calc(18 * var(--rpx)) auto 0;
  color: #8c8c8c;
  text-align: center;
  font-size: calc(22 * var(--rpx));
  line-height: 1.6;
}

.m-info-card {
  margin-top: calc(24 * var(--rpx));
  border-radius: calc(24 * var(--rpx));
  background: #fff;
  box-shadow: 0 calc(14 * var(--rpx)) calc(36 * var(--rpx)) rgba(56, 89, 126, 0.06);
}

.m-question-card {
  position: relative;
  display: block;
  min-height: calc(180 * var(--rpx));
  overflow: visible;
  padding: calc(42 * var(--rpx)) calc(34 * var(--rpx));

  div {
    min-width: 0;
  }

  h3 {
    margin: 0;
    color: #262626;
    font-size: calc(26 * var(--rpx));
    font-weight: 700;
    line-height: 1.4;
  }

  p {
    margin: calc(12 * var(--rpx)) 0 0;
    color: #8c8c8c;
    font-size: calc(21 * var(--rpx));
    line-height: 1.68;
  }

  &.has-icon {
    margin-top: calc(110 * var(--rpx));
  }

  &.has-icon div {
    max-width: calc(500 * var(--rpx));
  }

  .m-card-icon {
    position: absolute;
    top: calc(-116 * var(--rpx));
    right: calc(44 * var(--rpx));
    width: calc(220 * var(--rpx));
    height: auto;
    object-fit: contain;
    pointer-events: none;
  }
}

.m-guarantee-card {
  position: relative;
  min-height: calc(190 * var(--rpx));
  overflow: visible;
  padding: calc(42 * var(--rpx)) calc(34 * var(--rpx));

  &.has-icon {
    margin-top: calc(100 * var(--rpx));
  }

  &.has-icon div {
    max-width: calc(500 * var(--rpx));
  }

  .m-card-icon {
    position: absolute;
    top: calc(-96 * var(--rpx));
    right: calc(54 * var(--rpx));
    width: calc(190 * var(--rpx));
    height: auto;
    object-fit: contain;
    pointer-events: none;
  }

  h3 {
    margin: 0;
    color: #262626;
    font-size: calc(26 * var(--rpx));
    font-weight: 700;
    line-height: 1.4;
  }

  p {
    margin: calc(14 * var(--rpx)) 0 0;
    color: #8c8c8c;
    font-size: calc(22 * var(--rpx));
    line-height: 1.72;
  }
}

.m-process-section {
  padding-bottom: calc(44 * var(--rpx));
}

.m-process-panel {
  margin-top: calc(28 * var(--rpx));
  padding: calc(26 * var(--rpx));
  border-radius: calc(18 * var(--rpx));
  background: #fff;
}

.m-process-step {
  display: grid;
  grid-template-columns: calc(52 * var(--rpx)) minmax(0, 1fr);
  gap: calc(18 * var(--rpx));
  align-items: start;
  padding: calc(18 * var(--rpx)) 0;
  border-bottom: 1px solid #eef2f6;

  &:last-child {
    border-bottom: 0;
  }

  h3 {
    margin: 0;
    color: #262626;
    font-size: calc(24 * var(--rpx));
    line-height: 1.4;
  }

  p {
    margin: calc(8 * var(--rpx)) 0 0;
    color: #8c8c8c;
    font-size: calc(21 * var(--rpx));
    line-height: 1.55;
  }
}

.m-process-index {
  width: calc(52 * var(--rpx));
  height: calc(52 * var(--rpx));
  border-radius: 50%;
  color: #fff;
  text-align: center;
  font-size: calc(20 * var(--rpx));
  font-weight: 700;
  line-height: calc(52 * var(--rpx));
  background: linear-gradient(180deg, #7ec0ff 0%, #5da8ff 100%);
}

.m-experience-section {
  padding-bottom: calc(80 * var(--rpx));
  background: #fff;
}

.m-experience-qrs {
  display: block;
  width: min(calc(640 * var(--rpx)), 88vw);
  height: auto;
  margin: calc(42 * var(--rpx)) auto 0;
  border-radius: calc(18 * var(--rpx));
}

.m-qr-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: calc(40 * var(--rpx));
  background: rgba(15, 23, 42, 0.42);
}

.m-qr-dialog {
  position: relative;
  width: min(calc(520 * var(--rpx)), 82vw);
  padding: calc(40 * var(--rpx));
  border-radius: calc(18 * var(--rpx));
  background: #fff;
  box-shadow: 0 calc(24 * var(--rpx)) calc(70 * var(--rpx)) rgba(15, 23, 42, 0.22);

  img {
    display: block;
    width: 100%;
    height: auto;
  }
}

.m-qr-close {
  position: absolute;
  top: calc(10 * var(--rpx));
  right: calc(14 * var(--rpx));
  width: calc(46 * var(--rpx));
  height: calc(46 * var(--rpx));
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #8c8c8c;
  font-size: calc(38 * var(--rpx));
  line-height: calc(46 * var(--rpx));
}
</style>
